
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"52","height":"53","viewBox":"0 0 52 53","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.2342 0.5C40.4634 0.5 52 12.0396 52 26.2724C52 43.1859 33.3332 55.0061 26.2342 52.0448C21.2294 49.9563 23.8783 41.2907 15.9878 34.1899C9.03838 27.9494 2.34453 30.4805 0.468502 26.2724C-2.54187 19.4895 9.29392 0.5 26.2342 0.5ZM9.537 26.6278C13.8687 26.6839 17.9386 28.392 21.0113 31.4718C24.0965 34.5577 25.8042 38.6412 25.8541 42.9864H26.1408C26.1906 38.6412 27.8984 34.5577 30.9835 31.4718C34.05 28.3983 38.1261 26.6839 42.4578 26.6278V26.341C38.1261 26.2849 34.0562 24.5767 30.9835 21.497C27.9108 18.4297 26.1969 14.3588 26.1408 10.0197H25.8603C25.8042 14.3525 24.0965 18.4235 21.0175 21.497C17.9448 24.5767 13.8687 26.2849 9.537 26.341V26.6278Z","fill":"url(#paint0_linear_3556_5113)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_3556_5113","x1":"52","y1":"26.5031","x2":"-0.00517348","y2":"26.5031","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0.04","stop-color":"#FFCCF2"}}),_c('stop',{attrs:{"offset":"0.16","stop-color":"#C8A2F8"}}),_c('stop',{attrs:{"offset":"0.25","stop-color":"#A487FD"}}),_c('stop',{attrs:{"offset":"0.3","stop-color":"#967CFF"}}),_c('stop',{attrs:{"offset":"0.51","stop-color":"#2A47FF"}}),_c('stop',{attrs:{"offset":"0.61","stop-color":"#0033FF"}}),_c('stop',{attrs:{"offset":"0.85","stop-color":"#0600AB"}}),_c('stop',{attrs:{"offset":"0.99","stop-color":"#171E55"}})])])])
          )
        }
      }
    